module.exports = __webpack_public_path__ + "img/influcent-icon-blue.cd6737b0.png";